import { navigateToUrl } from "@helpers";
import useLightboxContext from "./useLightboxContext";

const useExitBuyFlowToHome = () => {
	const { setlightboxContext, removeLightboxContext } = useLightboxContext();

	const exitBuyFlowToHome = (e) => {
		e?.preventDefault?.();

		setlightboxContext({
			headline: "Looking for a promo code?",
			mainText:
				"Get 50% off your first three months with promo code FELIX50. Then $35/mth on a no lock-in contract. T+C apply.",
			primaryButton: {
				title: "Continue the switch",
				action: () => removeLightboxContext(),
			},
			secondaryButton: {
				title: "Back to home",
				action: () => navigateToUrl(e, "/"),
			},
		});
	};

	return exitBuyFlowToHome;
};

export default useExitBuyFlowToHome;
